import React from "react";

// Local
import { TitleContainer } from "../styled/styled";
import { LaurelLeft, LaurelRight } from "../assets/svg/Laurel";

const Title = () => {
  return (
    <TitleContainer className="title">
      <LaurelLeft />
      <h1 style={{ margin: "0 2em", maxWidth: "480px" }}>
        Circle of
        <br /> Nations
      </h1>
      <LaurelRight />
    </TitleContainer>
  );
};

export default Title;
